<template>
    <div class="module orderlist">
        <helpInfo :helpData="helpData"></helpInfo>
        <div class="module-container">
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr">
                <Button class="tootip-btn"
                        slot="tootipL"
                        @click="tableRefresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button slot="tootipL"
                        @click="exportData"
                        v-if="hasPermission('CC0102')"
                        :disabled="loading">
                    <i class="icon-export-1-o"
                       style="vertical-align: middle;"></i>
                    {{$t('导出')}}
                </Button>
                <Button slot="tootipL"
                        @click="downloadTask"
                        v-if="hasPermission('CC0102')"
                        :disabled="loading">
                    {{$t('下载任务')}}
                </Button>
                <!-- <Button slot="tootipL"
                        v-if="this.hasPermission('CC0102')"
                        @click="exportData">
                    <i class="icon-export-1-o"
                       style="vertical-align: middle;"></i> {{$t('导出')}}</Button> -->
            </rcTable>
        </div>
        <exportTime ref="exportTime" />
        <exportTable ref="exportTable" />
        <!-- <div v-if="loading">
            <Spin fix><span>{{$t('导出中')}}...</span></Spin>
        </div> -->
    </div>
</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import rcTable from '@/views/components/basic/rcTable'
import expandrow from '@/views/console/orders/components/tableexpand.vue'
import mixin from '@/mixin/mixin'
import API from '@/service/api'
import exportTime from './components/export-time.vue'
import exportTable from './components/export-table.vue'
export default {
    name: 'orderList',
    components: {
        helpInfo,
        rcTable,
        exportTime,
        exportTable
    },
    mixins: [mixin],
    data () {
        return {
            helpData: {
                modelName: this.$t('我的订单')
            },
            loading: false,
            adminFlag: true,
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_AUDIT_APPROVAL_ORDERS, false),
                    params: {
                        // adminFlag: true
                    }
                },
                searchColumns: [
                    {
                        title: this.$i18n.t('订单编号'),
                        key: 'orderSnLike',
                        searchDefaultValue: ''
                    },
                    {
                        title: this.$i18n.t('产品名称'),
                        key: 'nameLike',
                        searchDefaultValue: ''
                    }
                    // {
                    //     title: this.$i18n.t('状态'),
                    //     key: 'statusName',
                    //     searchType: 'select',
                    //     searchData: []
                    // },
                    // {
                    //     title: this.$i18n.t('类型'),
                    //     key: 'type',
                    //     searchType: 'select',
                    //     searchData: []
                    // },
                    // {
                    //     title: this.$i18n.t('提交人'),
                    //     key: 'ownerNameLike',
                    //     searchType: 'autoc'
                    // },
                    // {
                    //     title: this.$i18n.t('所属组织'),
                    //     key: 'orgNameLike',
                    //     searchType: 'autoc'
                    // }
                ],
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                referenceVal: 1450,
                columns: [
                    {
                        type: 'expand',
                        width: 40,
                        render: (h, params) => {
                            return h(expandrow, {
                                on: {
                                    // refresh: this.refresh
                                    // editModal: this.editModal
                                },
                                props: {
                                    data: params.row,
                                    tabPane: this.tabPane
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('订单编号'),
                        key: 'orderSn',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 170,
                        render: (h, params) => {
                            const { orderSn, id } = params.row
                            return h(this.hasPermission('CC0103') ? 'a' : 'span', { class: 'tbl-operate', on: { click: () => this.hasPermission('CC0103') && this.toDetails(id) } }, orderSn)
                        }
                    },
                    {
                        title: this.$t('账户ID'),
                        key: 'accountId',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            const { accountId } = params.row
                            return h('span', { class: 'tbl-operate', attrs: { title: this.$t(accountId) } }, accountId || '--')
                        }
                    },
                    {
                        title: this.$t('账户名称'),
                        key: 'entityName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            const { entityName } = params.row
                            return h('span', { class: 'tbl-operate', attrs: { title: this.$t(entityName) } }, entityName || '--')
                        }
                    },
                    {
                        title: this.$t('产品名称'),
                        key: 'name',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            const { name } = params.row
                            return h('span', { attrs: { title: name } }, name || '--')
                        }
                    },
                    {
                        title: this.$t('产品类别'),
                        key: 'productNameLike',
                        sortable: true,
                        sortKey: 'productName',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            const { productName } = params.row
                            return h('span', { attrs: { title: this.$t(productName) } }, this.$t(productName))
                        }
                    },
                    {
                        title: this.$t('计费方式'),
                        key: 'chargeType',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        filterMultiple: false,
                        filters: [
                            { value: 'PrePaid', label: this.$t('包年包月') },
                            { value: 'PostPaid', label: this.$t('按量付费') },
                            { value: 'None', label: this.$t('不计费') }
                        ],
                        render: (h, params) => {
                            const { chargeType } = params.row
                            const text = chargeType === 'PrePaid' ? this.$t('包年包月') : chargeType === 'None' ? this.$t('不计费') : this.$t('按量付费')
                            return h('span', { attrs: { title: text } }, text)
                        }
                    },
                    {
                        title: this.$t('类型'),
                        key: 'typeName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        // disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 80,
                        filterMultiple: false,
                        filters: [],
                        filtersKey: 'type',
                        render: (h, params) => h('span', { attrs: { title: this.$t(params.row.typeName) } }, this.$t(params.row.typeName))
                    },
                    // {
                    //     title: '提交人',
                    //     key: 'applicant',
                    //     sortable: false,
                    //     columnShow: true,
                    //     columnsChoosed: false,
                    //     disabledSearch: true
                    // },
                    // {
                    //     title: '所属组织',
                    //     key: 'orgName',
                    //     sortable: false,
                    //     columnShow: true,
                    //     columnsChoosed: true,
                    //     disabledSearch: true
                    // },
                    {
                        title: this.$t('订单提交时间'),
                        key: 'createdDt',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => h('span', { attrs: { title: params.row.createdDt } }, params.row.createdDt)
                    },
                    {
                        title: this.$t('开通时间'),
                        key: 'payTime',
                        columnShow: true,
                        columnsChoosed: false,
                        disabledSearch: true,
                        className: 'ellipsis',
                        sortable: 'custom',
                        resizable: true,
                        width: 150,
                        render: (h, params) => h('span', { attrs: { title: params.row.payTime } }, params.row.payTime)
                    },
                    {
                        title: this.$t('状态'),
                        key: 'statusName',
                        sortable: false,
                        sortKey: 'status',
                        columnShow: true,
                        columnsChoosed: true,
                        // disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        filterMultiple: false,
                        filters: [],
                        render: (h, params) => {
                            const { status, statusName, statusInfo } = params.row
                            const errStatus = ['lev2_refused', 'release_lev2_refused', 'renew_lev2_refused', 'failure']
                            const isFailed = errStatus.includes(status)
                            const comp = isFailed ? 'syncpoptip' : 'statusview'
                            const props = isFailed ? {
                                value: this.$t(statusName),
                                isStatic: true,
                                errMsg: statusInfo
                            } : {
                                state: status,
                                stateName: statusName
                            }
                            return h(comp, { props })
                        }
                    },
                    {
                        title: this.$t('原价'),
                        key: 'originalCost',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        sortable: 'custom',
                        width: 130,
                        align: 'right',
                        render: (h, params) => {
                            const { originalCost } = params.row
                            return h('span', {
                                class: originalCost >= 0 ? 'balance-color' : 'balance-color-green'
                            }, this.$money(originalCost))
                        }
                    },
                    {
                        title: this.$t('优惠金额'),
                        key: 'orgDiscount',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        sortable: 'custom',
                        resizable: true,
                        width: 130,
                        align: 'right',
                        render: (h, params) => {
                            const { orgDiscount, couponDiscount, couponAmount, deductCouponDiscount } = params.row
                            const amount = orgDiscount + couponDiscount + couponAmount + deductCouponDiscount
                            const display = amount > 0 ? 'inline' : 'none'
                            return h('Poptip', {
                                class: 'balance-color',
                                props: {
                                    disabled: amount === 0,
                                    trigger: 'hover',
                                    placement: params.index === 0 ? 'right' : 'right-end'
                                }
                            }, [
                                this.$money(amount),
                                h('i', { style: { display, 'padding-left': '5px', color: '#2d8cf0' }, class: 'icon-prompt-1-o' }),
                                h('div', {
                                    slot: 'content',
                                    style: {
                                        'text-align': 'left'
                                    }
                                }, [
                                    [
                                        h('p', this.$t('充值现金券') + `:${this.$money(couponAmount || 0)}`),
                                        h('p', this.$t('抵扣现金券') + `:${this.$money(deductCouponDiscount || 0)}`),
                                        h('p', this.$t('优惠券抵扣') + `:${this.$money(couponDiscount || 0)}`),
                                        h('p', {
                                            style: {
                                                'padding-left': '12px'
                                            }
                                        }, this.$t('折扣优惠') + `:${this.$money(orgDiscount || 0)}`)
                                    ]
                                ])
                            ])
                        }
                    },
                    {
                        title: this.$t('现金支付金额'),
                        key: 'cashAmount',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        // resizable: true,
                        sortable: true,
                        minWidth: 120,
                        align: 'right',
                        // renderHeader: (h, params) => {
                        //     return h('span', {
                        //         class: 'ellipsis',
                        //         attrs: { title: this.$t('支付金额') },
                        //         style: {
                        //             display: 'inline-block',
                        //             width: '100px',
                        //             overflow: 'hidden',
                        //             'white-space': 'nowrap',
                        //             'text-overflow': 'ellipsis',
                        //             'padding-right': '18px'
                        //         }
                        //     }, this.$t('支付金额'))
                        // },
                        render: (h, params) => {
                            const { cashAmount } = params.row
                            return h('span', { class: cashAmount >= 0 ? 'balance-color' : 'balance-color-green', style: { display: 'block' } }, this.$money(cashAmount))
                        }
                    },
                    {
                        title: this.$t('信用额度支付金额'),
                        key: 'creditAmount',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        resizable: true,
                        width: 180,
                        align: 'right',
                        renderHeader: (h, params) => h('span', { attrs: { title: this.$i18n.t('信用额度支付金额') }, class: 'rc-ellipsis', style: 'padding-right: 15px;width:80%;display: inline-block;' }, this.$t('信用额度支付金额')),
                        render: (h, params) => {
                            const { creditAmount } = params.row
                            return h(
                                'span',
                                { class: Number(params.row.creditAmount) < 0 ? 'balance-color-green' : 'balance-color' },
                                this.$money(creditAmount)
                            )
                        }
                    },
                    {
                        title: this.$t('收费规则'),
                        key: 'chargingType',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        width: 120,
                        resizable: true,
                        render: (h, { row }) => {
                            const txt = this.$t({ '01': '正常计费', '02': '销售计费' }[row.chargingType || '01'])
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    }
                    // {
                    //     title: this.$t('操作'),
                    //     key: '',
                    //     width: 100,
                    //     fixed: 'right',
                    //     render: (h, params) => {
                    //         return h('div', { class: 'tbl-btn-div' }, [
                    //             h('a', { on: { click: () => { this.toDetails(params.row.id) } } }, this.$t('详情'))
                    //         ])
                    //     }
                    // }
                ]
            }
        }
    },
    created () {
        // this.adminFlag = this.$route.name === 'ordersManager'
        // if (!this.adminFlag) this.helpData.modelName = this.$t('我的订单')
        // this.tableAttr.source.params.adminFlag = this.adminFlag
        // this.tableAttr.columns = this.tableAttr.columns.filter(elm => {
        //     return !['applicant', 'orgName'].includes(elm.key) || this.adminFlag
        // })
        // this.tableAttr.searchColumns = this.tableAttr.searchColumns.filter(elm => {
        //     return (!['orgNameLike', 'ownerNameLike'].includes(elm.key) || this.adminFlag)
        // })
        this.get_orderType()
        this.get_orderStatus()
    },
    methods: {
        tableRefresh () {
            this.$refs.rcTable.refreshTable()
        },
        get_orderType () {
            this.axios.get(this.urlFormat(API.GET_CODE_DATA + '/ORDER_TYPE', true)).then(res => {
                const index = this.tableAttr.columns.findIndex(col => col.key === 'typeName')
                if (index !== -1) {
                    this.tableAttr.columns[index].filters = res.map(item => {
                        return { label: this.$t(item.codeDisplay), value: item.codeValue }
                        // }).filter(item => item.value !== 'modify') // 修改bug33628，去掉modify（类型：变更）的过滤
                    })
                }
            })
        },
        get_orderStatus () {
            this.axios.get(this.urlFormat(API.GET_CODE_DATA + '/ORDER_STATUS', true)).then(res => {
                const index = this.tableAttr.columns.findIndex(col => col.key === 'statusName')
                this.tableAttr.columns[index].filters = res.map(item => {
                    return { label: this.$t(item.codeDisplay), value: item.codeValue }
                })
            })
        },
        toDetails (id) {
            this.$router.push({ path: '/mgt/orders/' + id })
        },
        searchParams () {
            const params = JSON.parse(JSON.stringify(this.tableAttr.source.params))
            const searchVal = this.$refs.rcTable.searchValueList || []
            for (const { key, value } of searchVal) {
                params[key] = value
            }
            return params
        },
        exportData () {
            this.$refs.exportTime.open({
                title: this.$t('订单导出'),
                api: this.urlFormat(API.AUDIT_APPROVAL_ASYN_EXPORT, true),
                params: this.searchParams()
            })
            // 查询条件
            // this.loading = true
            // const [userSid] = [this.$store.state.user.currentUser.info.userSid, '', '']
            // const params = this.$refs.rcTable.searchValueList.map(item => `${item.key}=${item.value}`).join('&')
            // let url = this.urlFormat(API.GET_AUDIT_APPROVAL_EXPORT + '?' + params, true)
            // if (params.length === 0) {
            //     url = this.urlFormat(API.GET_AUDIT_APPROVAL_EXPORT, true)
            // }
            // this.axios({
            //     method: 'get',
            //     url: url,
            //     headers: {
            //         token: userSid
            //     },
            //     responseType: 'blob'
            // }).then(res => {
            //     if (res) {
            //         // 文件下载
            //         this.$Message.success(this.$t('导出成功'))
            //         this.loading = false
            //     }
            // }).catch(e => {
            //     this.$Message.error(this.$t('导出失败'))
            //     this.loading = false
            // })
        },
        downloadTask () {
            this.$refs.exportTable.open({
                title: this.$t('下载任务'),
                operationType: 'service_order'
            })
        }
    }
}
</script>

<style lang="less">
.orderlist {
    .ivu-table-wrapper {
        overflow: visible;
    }
}
</style>
